import { useEffect } from 'react';

const useOutsideClick = ({ enabled, getContainer, onOutside }) => {
    useEffect(() => {
        if (!enabled) return;

        const handleClickOutside = (e) => {
            const container = typeof getContainer === 'function' ? getContainer() : null;
            if (container && !container.contains(e.target)) {
                onOutside?.(e);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [enabled, getContainer, onOutside]);
};

export default useOutsideClick;
